export interface PostItem {
  imgSrc: string;
  href: string;
  label: string;
}

export const RelatedPostsInBody: React.FC<{
  postItems: PostItem[];
  bgColor?: string | null;
  heading?: string | null;
}> = ({ postItems, heading, bgColor }) => (
  <>
    {heading && (
      <>
        <p>&nbsp;</p>
        <h2>{heading}</h2>
      </>
    )}
    <div
      style={bgColor ? { backgroundColor: bgColor } : undefined}
      className={bgColor ? 'p-4' : ''}
    >
      {postItems.map((e, i, all) => (
        <div key={i} className={`flex ${i < all.length - 1 ? 'mb-4' : ''}`}>
          <div className='shrink-0'>
            <a href={e.href}>
              <img
                style={{ margin: 0 }}
                className='w-[120px] sm:w-[150px]'
                src={e.imgSrc}
                height='99'
                decoding='async'
                loading='lazy'
                sizes='150px'
                alt={e.label}
              />
            </a>
          </div>
          <div className='flex items-start pl-4 sm:text-lg'>
            <a href={e.href} className='line-clamp-3'>
              {e.label}
            </a>
          </div>
        </div>
      ))}
    </div>
  </>
);
